import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DOMPurify from "dompurify";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

const baseUrl = "https://api.shabdtoday.com/";
const online = `${baseUrl}api/home/tajaKhabars`;
const clickonline = `${baseUrl}api/home/update-viewcount`;

const isDesktopScreen = () => window.innerWidth >= 1024;

const truncateText = (text, maxLength) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";
  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      newNode = document.createTextNode(
        charCount >= maxLength && !isTruncated ? truncated + "..." : truncated
      );
      if (charCount >= maxLength) isTruncated = true;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) newNode.appendChild(traverse(child));
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};

const stripHtmlTags = (html, maxLength) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.textContent || div.innerText || "";
  return truncateText(text, maxLength);
};

const Technologes = () => {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const observer = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsDesktop(isDesktopScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const cachedNews = sessionStorage.getItem("techNewsData");
  //   const cachedPage = sessionStorage.getItem("techNewsPage");
  //   const cachedScroll = sessionStorage.getItem("techScrollY");

  //   if (cachedNews) {
  //     setNews(JSON.parse(cachedNews));
  //     setPage(Number(cachedPage) || 1);
  //     setLoading(false);
  //     setTimeout(() => {
  //       window.scrollTo(0, Number(cachedScroll) || 0);
  //     }, 200);
  //   } else {
  //     fetchNews();
  //   }
  // }, []);

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     sessionStorage.setItem("techNewsData", JSON.stringify(news));
  //     sessionStorage.setItem("techNewsPage", page);
  //     sessionStorage.setItem("techScrollY", window.scrollY);
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   window.addEventListener("pagehide", handleBeforeUnload);
  //   return () => {
  //     handleBeforeUnload();
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     window.removeEventListener("pagehide", handleBeforeUnload);
  //   };
  // }, [news, page]);

  const fetchNews = async () => {
    if (fetching || !hasMore) return;
    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);
      const fetchedNews =
        response.data.tazaKhabars ||
        response.data.TajaKhabars ||
        response.data ||
        [];

      if (Array.isArray(fetchedNews) && fetchedNews.length > 0) {
        setNews((prevNews) => {
          const existing = new Set(prevNews.map((n) => n.mainKhabarId));
          const newItems = fetchedNews.filter(
            (n) => n.mainKhabarId && !existing.has(n.mainKhabarId)
          );
          const updated = [...prevNews, ...newItems];
          sessionStorage.setItem("techNewsData", JSON.stringify(updated));
          sessionStorage.setItem("techNewsPage", page + 1);
          return updated;
        });
        setPage((p) => p + 1);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching news:", err);
      setError("समाचार लोड नहीं हो सके। कृपया पुनः प्रयास करें।");
    } finally {
      setFetching(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) fetchNews();
    });
    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);
  }, [news]);

  const handleNewsClick = async (slug, mainKhabarId) => {
    try {
      await axios.post(clickonline, { mainKhabarId });
    } catch (err) {
      console.error("Error updating view count:", err);
    } finally {
      navigate(`/News-Details/${slug}`);
    }
  };

  const generateShareLinks = (mainKhabarId, newsHeading) => {
    const encoded = encodeURIComponent(newsHeading);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encoded}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encoded} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encoded}&url=${url}`,
    };
  };

  if (error)
    return <div style={{ textAlign: "center", padding: "20px" }}>{error}</div>;

  return (
    <div>
      <Helmet>
        <title>आज की टेक्नोलॉजी की ताज़ा खबरें हिंदी में | देश दुनिया की नवीनतम टेक न्यूज़ | Technology News Hindi</title>
        <meta name="title" content="आज की टेक्नोलॉजी की ताज़ा खबरें हिंदी में | देश दुनिया की नवीनतम टेक न्यूज़ | Technology News Hindi" />
        <meta name="description" content="आज की टेक्नोलॉजी की ताज़ा खबरें हिंदी में पढ़ें। देश दुनिया की तकनीक से जुड़ी नवीनतम खबरें, मोबाइल लॉन्च, गैजेट अपडेट, AI, इंटरनेट, साइबर सिक्योरिटी और सभी टेक न्यूज़ की आज की ताज़ा हिंदी अपडेट।" />
        <meta name="keywords" content="Technology News Hindi, टेक्नोलॉजी की ताज़ा खबरें, आज की टेक न्यूज़, टेक न्यूज़ हिंदी, मोबाइल लॉन्च खबरें, गैजेट अपडेट, टेक्नोलॉजी समाचार हिंदी, cyber security news hindi, AI news hindi, आज की ताज़ा टेक्नोलॉजी खबरें, तकनीक से जुड़ी खबरें, Latest tech news hindi" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />
        <link rel="canonical" href="https://shabdtoday.com/Technology-News" />
        <meta property="og:title" content="टेक्नोलॉजी न्यूज़ हिंदी – गैजेट और अपडेट" />
        <meta property="og:description" content="नए मोबाइल, गैजेट्स और टेक ऐप की ताज़ा खबरें हिंदी में।" />
        <meta property="og:url" content="https://shabdtoday.com/Technology-News" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />
        {/* <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "टेक्नोलॉजी समाचार – ShabdToday",
            "url": "https://shabdtoday.com/Technology-News",
            "description": "नए ऐप्स, गैजेट्स और टेक अपडेट हिंदी में।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script> */}
      </Helmet>
      {/* <h1 className="visually-hidden">टेक्नोलॉजी अपडेट हिंदी में</h1> */}
      {/* <h2 className="visually-hidden">गैजेट न्यूज़, स्मार्टफोन और ऐप्स</h2>
      <h3 className="visually-hidden" s>नवीनतम टेक ट्रेंड्स और समीक्षा</h3> */}
      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_taja_news"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const shareLinks = generateShareLinks(
                        post.mainKhabarId,
                        post.newsHeading
                      );
                      const cleanTag = DOMPurify.sanitize(post.newsTag || "");
                      const htmlContent = isDesktop
                        ? truncateHtml(cleanTag, 100)
                        : cleanTag;

                      return (
                        <article
                          key={post.mainKhabarId}
                          className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post"
                          style={{
                            border: "0.5px solid #d4d4d4ff",
                            marginBottom: "2px",
                            borderRadius: "4px",
                          }}
                        >
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">
                              <div className="ak-featured-cover">

                                {/* ✅ Title Link */}
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  rel="bookmark"
                                  title={stripHtmlTags(post.newsTag, 100)}
                                  onClick={async (e) => {
                                    if (
                                      e.button === 1 ||
                                      e.metaKey ||
                                      e.ctrlKey ||
                                      e.shiftKey
                                    )
                                      return; // allow open in new tab
                                    e.preventDefault();
                                    await handleNewsClick(
                                      post.slug,
                                      post.mainKhabarId
                                    );
                                  }}
                                >
                                  <h2 className="ak-module-title">
                                    <span
                                      className="responsive-font"
                                      style={{
                                        lineHeight: "35px",
                                        fontSize: "20px",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: htmlContent,
                                      }}
                                    />
                                  </h2>
                                </Link>

                                {/* ✅ Image Link */}
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  className="ak-featured-link"
                                  rel="bookmark"
                                  title={stripHtmlTags(post.newsTag)}
                                  onClick={async (e) => {
                                    if (
                                      e.button === 1 ||
                                      e.metaKey ||
                                      e.ctrlKey ||
                                      e.shiftKey
                                    )
                                      return;
                                    e.preventDefault();
                                    await handleNewsClick(
                                      post.slug,
                                      post.mainKhabarId
                                    );
                                  }}
                                >
                                  <img
                                    src={baseUrl + post.newsImage}
                                    alt={post.slug}
                                    width={600}
                                    height={300}
                                    style={{
                                      width: "100%",
                                      height: "auto",
                                      borderRadius: "4px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Link>

                              </div>
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>लोड हो रहा है...</p>}
        {!hasMore && <p>कोई और समाचार उपलब्ध नहीं हैं।</p>}
      </div>
    </div>
  );
};

export default Technologes;
